<app-button 
  [matMenuTriggerFor]="menu" 
  #menuTrigger
  icon="more"
  size="small"
></app-button>

<mat-menu #menu="matMenu" xPosition="before">
  <ng-content></ng-content>
</mat-menu>